import {
    GENERATE_QUESTION,
    GENERATE_QUESTION_SUCCESS,
    GENERATE_QUESTION_FAILURE,
    GET_QUESTIONS,
    GET_QUESTIONS_SUCCESS,
    GET_QUESTIONS_FAILURE,
    POST_QUESTION,
    POST_QUESTION_SUCCESS,
    POST_QUESTION_FAILURE,
    DELETE_QUESTION_SET,
    DELETE_QUESTION_SET_SUCCESS,
    DELETE_QUESTION_SET_FAILURE,
    GET_QUESTION_LIBRARY,
    GET_QUESTION_LIBRARY_SUCCESS,
    GET_QUESTION_LIBRARY_FAILURE,
    GET_ALL_PERMISSION,
    GET_ALL_PERMISSION_SUCCESS,
    GET_ALL_PERMISSION_FAILURE,
    FETCH_LANGUAGE_QUESTION,
    FETCH_LANGUAGE_QUESTION_SUCCESS,
    FETCH_LANGUAGE_QUESTION_FAILURE,
    FETCH_PSYCHOMETRIC_ROLES,
    FETCH_PSYCHOMETRIC_ROLES_SUCCESS,
    FETCH_PSYCHOMETRIC_ROLES_FAILURE,
} from '../action/types';
const INIT_STATE = {
    loading: false,
    lists: null,
    questions: null,
    answer: null,
    coding: false,
    aptitudePermission: false,
    conversation: false,
    questionLibrary: [],
    libraryLoading: false,
    skill_based_evaluation: false,
    fullyConversation: false,
    interviewLanguagePermission: false,
    companyIntroPermission: false,
    aiPersonaPermission: false,
    cefr_evaluation: false,
    psychometric_evaluation: false,
    psychometricRoles: [],
    psychometricRolesLoading: false,
    timezoneConfiguration: false,
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_PSYCHOMETRIC_ROLES:
            return { ...state, psychometricRolesLoading: true };
        case FETCH_PSYCHOMETRIC_ROLES_SUCCESS:
            return {
                ...state,
                psychometricRolesLoading: false,
                psychometricRoles: action.payload || [],
            };
        case FETCH_PSYCHOMETRIC_ROLES_FAILURE:
            return { ...state, psychometricRolesLoading: false };
        case FETCH_LANGUAGE_QUESTION:
            return { ...state, loading: true };
        case FETCH_LANGUAGE_QUESTION_SUCCESS:
            return { ...state, loading: false };
        case FETCH_LANGUAGE_QUESTION_FAILURE:
            return { ...state, loading: false };

        case GET_QUESTIONS:
            return { ...state, loading: true };
        case GET_QUESTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                lists: action.payload,
            };
        case GET_QUESTIONS_FAILURE:
            return { ...state, loading: false };
        case POST_QUESTION:
            return { ...state, loading: true };
        case POST_QUESTION_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_QUESTION_FAILURE:
            return { ...state, loading: false };
        case DELETE_QUESTION_SET:
            return { ...state, loading: true };
        case DELETE_QUESTION_SET_SUCCESS:
            return { ...state, loading: false };
        case DELETE_QUESTION_SET_FAILURE:
            return { ...state, loading: false };
        case GENERATE_QUESTION:
            return { ...state, loading: true };
        case GENERATE_QUESTION_SUCCESS:
            return {
                ...state,
                loading: false,
                questions: action.payload,
            };
        case GENERATE_QUESTION_FAILURE:
            return { ...state, loading: false };

        case GET_QUESTION_LIBRARY:
            return { ...state, libraryLoading: true };
        case GET_QUESTION_LIBRARY_SUCCESS:
            return { ...state, libraryLoading: false, questionLibrary: action.payload?.questions };
        case GET_QUESTION_LIBRARY_FAILURE:
            return { ...state, libraryLoading: false };

        case GET_ALL_PERMISSION:
            return { ...state, loading: true };
        case GET_ALL_PERMISSION_SUCCESS:
            return {
                ...state,
                loading: false,
                coding: action.payload?.coding_question,
                aptitudePermission: action.payload?.aptitude_question || false,
                writtenTestPermission: action.payload?.writing_questions || false,
                conversation: action.payload?.conversation_ai || false,
                skill_based_evaluation: action.payload?.skill_based_evaluation || false,
                fullyConversation: action.payload?.fully_conversational_status || false,
                interviewLanguagePermission: action.payload?.interview_language_permission || false,
                companyIntroPermission: action.payload?.intro_bio_video_configuration || false,
                aiPersonaPermission: action.payload?.hiring_manager_persona || false,
                cefr_evaluation: action.payload?.cefr_interview_type || false,
                psychometric_evaluation: action.payload?.psychometric_interview_type || false,
                timezoneConfiguration: action.payload?.timezone_configuration || false,
            };
        case GET_ALL_PERMISSION_FAILURE:
            return { ...state, loading: false };

        default:
            return state;
    }
};
